export default __webpack_public_path__ + "static/media/3.0d456bc2.png";